
import React from "react";
import AboutHeroRedesigned from "@/components/landing/about/AboutHeroRedesigned";
import CombinedTeamSection from "@/components/landing/about/CombinedTeamSection";
import MissionVisionSection from "@/components/landing/about/sections/MissionVisionSection";
import SimplifiedTechnologySection from "@/components/landing/about/sections/SimplifiedTechnologySection";
import IndustryRecognitionSection from "@/components/landing/about/sections/IndustryRecognitionSection";
import ComparisonTool from "@/components/landing/about/ComparisonTool";
import TestimonialsSection from "@/components/landing/about/TestimonialsSection";
import AboutPageSection from "./AboutPageSection";

const AboutPageContent: React.FC = () => {
  return (
    <article itemScope itemType="https://schema.org/AboutPage" className="flex flex-col">
      {/* Hero Section */}
      <AboutPageSection
        id="about-hero"
        className="py-0 relative bg-gradient-to-b from-white to-blue-50/30"
        ariaLabelledBy="hero-heading"
      >
        <AboutHeroRedesigned />
      </AboutPageSection>

      {/* Team Section - Primary focus, builds trust early */}
      <AboutPageSection
        id="our-team"
        className="py-0 bg-gradient-to-b from-blue-50/30 via-indigo-50/40 to-purple-50/30"
        ariaLabelledBy="team-heading"
      >
        <div itemProp="articleSection">
          <CombinedTeamSection />
        </div>
      </AboutPageSection>

      {/* Mission & Vision Section - Right after team to tell the story */}
      <AboutPageSection
        id="mission-vision"
        className="py-0 bg-gradient-to-b from-purple-50/30 via-blue-50/20 to-emerald-50/30"
        ariaLabelledBy="mission-vision-heading"
      >
        <div itemProp="articleSection">
          <MissionVisionSection />
        </div>
      </AboutPageSection>

      {/* Technology Section - How we deliver value */}
      <AboutPageSection
        id="technology"
        className="py-0 bg-gradient-to-b from-emerald-50/30 via-cyan-50/20 to-blue-50/30"
        ariaLabelledBy="technology-heading"
      >
        <div itemProp="articleSection">
          <SimplifiedTechnologySection />
        </div>
      </AboutPageSection>

      {/* Industry Recognition & Trust - New SEO-rich section */}
      <AboutPageSection
        id="industry-recognition"
        className="py-0 bg-gradient-to-b from-blue-50/30 via-indigo-50/20 to-gray-50/40"
        ariaLabelledBy="recognition-heading"
      >
        <div itemProp="articleSection">
          <IndustryRecognitionSection />
        </div>
      </AboutPageSection>

      {/* Competitive Advantage - Why choose us */}
      <AboutPageSection
        id="why-choose-us"
        className="py-16 bg-gradient-to-b from-gray-50/40 via-blue-50/20 to-white"
        ariaLabelledBy="comparison-heading"
      >
        <h2
          id="comparison-heading"
          className="text-3xl md:text-4xl font-bold text-center mb-12"
        >
          <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            Why Pet Families Choose My Pet ID
          </span>
        </h2>
        <div itemProp="articleSection">
          <ComparisonTool />
        </div>
      </AboutPageSection>

      {/* Testimonials - Social proof and closing */}
      <AboutPageSection
        id="testimonials"
        className="py-16 bg-white"
        ariaLabelledBy="testimonials-heading"
      >
        <div className="max-w-6xl mx-auto">
          <h2
            id="testimonials-heading"
            className="text-3xl md:text-4xl font-bold text-center mb-12"
          >
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              What Pet Families Say
            </span>
          </h2>
          <div itemProp="reviewBody">
            <TestimonialsSection />
          </div>
        </div>
      </AboutPageSection>
    </article>
  );
};

export default AboutPageContent;
